import OfflineDetector from 'elements/OfflineDetector'
import { GlobalContext } from 'Global'
import React from 'react'
import { Card, Col, Layout, Row } from 'antd'
import LoginFormCont from '../components/LoginFormCont'

const { Content } = Layout

function Login({ location }) {
  const { from } = location.state || { from: { pathname: '/' } }
  const { logo, siteTitle, primaryColor } = React.useContext(GlobalContext)

  console.log({ logo })
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-200 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <img className={`mx-auto max-h-64 w-auto mb-4`} src={logo} />
          <h2 className={`mt - 6 text-center text-3xl font-extrabold text-${primaryColor}-900`}>{siteTitle}</h2>
          <p className={`mt - 2 text-center text-sm text-${primaryColor}-600`}>
            <a href="#" className={`font-medium text-${primaryColor}-600 hover:text-${primaryColor}-500`}>
              Sign in to your account
            </a>
          </p>
        </div>

        <OfflineDetector />
        <LoginFormCont from={from} />
      </div>
    </div>
  )
}

export default Login
